var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_271_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1536_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1286_",
    x: 12.45,
    width: 1,
    height: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1535_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1285_",
    x: 7.22,
    width: 1,
    height: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1534_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1284_",
    x: 2.38,
    width: 1,
    height: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1533_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1279_",
    className: "st0",
    cx: 7.74,
    cy: 11.18,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1280_",
    d: "M7.74,13.2c-1.11,0-2.02-0.91-2.02-2.02s0.91-2.02,2.02-2.02s2.02,0.91,2.02,2.02S8.85,13.2,7.74,13.2z  M7.74,10.16c-0.56,0-1.02,0.46-1.02,1.02s0.46,1.02,1.02,1.02s1.02-0.46,1.02-1.02S8.3,10.16,7.74,10.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1532_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1275_",
    className: "st0",
    cx: 3.05,
    cy: 4.43,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1276_",
    d: "M3.05,6.45c-1.11,0-2.02-0.91-2.02-2.02s0.91-2.02,2.02-2.02s2.02,0.91,2.02,2.02S4.16,6.45,3.05,6.45z  M3.05,3.41c-0.56,0-1.02,0.46-1.02,1.02s0.46,1.02,1.02,1.02s1.02-0.46,1.02-1.02S3.61,3.41,3.05,3.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1531_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1264_",
    className: "st0",
    cx: 12.95,
    cy: 4.43,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1272_",
    d: "M12.95,6.45c-1.11,0-2.02-0.91-2.02-2.02s0.91-2.02,2.02-2.02s2.02,0.91,2.02,2.02 S14.06,6.45,12.95,6.45z M12.95,3.41c-0.56,0-1.02,0.46-1.02,1.02s0.46,1.02,1.02,1.02s1.02-0.46,1.02-1.02 S13.51,3.41,12.95,3.41z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControls);
export default __webpack_public_path__ + "static/media/Controls.e5bfc0c90e92c20f790f86577c20a3aa.svg";
export { ForwardRef as ReactComponent };